export default __webpack_public_path__ + "static/media/introductory_image2.700b0280.svg";